<template>
    <div class="fixed z-50 pin overflow-auto bg-modal" :class="active ? 'block' : 'hidden'" v-if="appointment">
        <div class="shadow max-w-sm mx-auto mt-24 px-4 md:px-0">
            <div class="bg-white rounded-t p-6">
                <div class="text-center text-grey-dark leading-normal">
                    {{ $t('To_cancel_the_appointment_call_the_doctor_via_X', {phoneNumber: appointment.officePhone}) }}
                </div>
            </div>
            <div class="flex md:hidden border-t items-center">
                <button @click="close" class="block text-center bg-white rounded-bl w-1/2 border-r py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-black">
                    {{ $t('Cancel') }}
                </button>
                <a :href="'tel:' + appointment.officePhone" class="block text-center bg-white rounded-br w-1/2 py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-blue">
                    {{ $t('Call') }}
                </a>
            </div>
            <div class="hidden md:flex border-t">
                <button @click="close" class="bg-white rounded-b w-full text-grey-dark py-3 uppercase tracking-wide font-semibold text-sm hover:text-black">
                    {{ $t('Cancel') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app'
import helpers from '@/mixins/helpers'

export default {
    name: 'cancel-appointment-modal',

    props: ['active', 'appointment'],

    mixins: [helpers],

    methods: {
        close () {
            this.$emit('close')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Patient/CancelAppointmentModal.vue